import { get, post } from "../httpInterceptor";

export const getAllProduct = () => {
	return get(`/sarvagram-credit/masternew/getproductmaster`).then((res) => {
		console.log("RESPONSE :: getAllProduct ::: ", res);
		return res;
	});
};
